import { BrowserRouter as Router, Routes, Route, useNavigate} from 'react-router-dom';
import  React, {use, useState, useEffect} from 'react';
import "./styles/MenuHomeBox.css";

import { TbReportSearch } from "react-icons/tb";
import { FaUser } from "react-icons/fa";
import { PiStudentFill } from "react-icons/pi";
import { FaHistory } from "react-icons/fa";

import Cookies from 'js-cookie';

//ValFoPr
const MenuHomeBox = () =>{

    const [isAdmin, setIsAdmin] = useState();

    const validarSesion = () =>{
            if(Cookies.get("turid")){
                const turid = Cookies.get("turid");
                if(turid === "rid1"){
                    setIsAdmin(true);
                }else{
                    setIsAdmin(false);
                }
                
            }else{
                navigate("/");
                Cookies.remove("usr");
            }
    }

    useEffect(() =>{
        validarSesion();
    },[])

    const navigate = useNavigate();

    
    const redireccionarRegistro = () =>{
        console.log('redireccionando');
        navigate('/Registrar');
    }

    const redireccionarRelacion = () =>{
        navigate('/Relacion');
    }

    const redireccionarGestionUsuarios = () =>{
        navigate('/adminPanel')
    }

    const redireccionarHistorial = () =>{
        navigate('/logs')
    }

    return(
        <div className="menuHomeBox">
            <div id="optionMenuHome">
                    <h2>Gestión de Alumnos</h2>
                    <div className='menuHomeBtnContainer'>
                        {isAdmin && <button onClick={redireccionarRegistro} className="buttonStandart" id="mainMenuButtons"><PiStudentFill size="40px"/> Registar alumno</button>}
                        <button onClick={redireccionarRelacion} className="buttonStandart" id="mainMenuButtons"><TbReportSearch size="40px"/>Obtener reporte</button>                        
                    </div>
                    {isAdmin&&<h2>Administración de usuarios</h2>}
                    {isAdmin &&
                    <div className='menuHomeBtnContainer'>
                        <button className="buttonStandart" id="mainMenuButtons" onClick={redireccionarGestionUsuarios}><FaUser size="40px"/>Gestionar usuarios</button>
                        <button className="buttonStandart" id="mainMenuButtons" onClick={redireccionarHistorial}><FaHistory size="40px"/>Historial de modificaciones</button>
                    </div>
                    }

            </div>
        </div> 

    );
}

export default MenuHomeBox;